/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthIntegration } from './PalAuthIntegration';
import {
    PalAuthIntegrationFromJSON,
    PalAuthIntegrationFromJSONTyped,
    PalAuthIntegrationToJSON,
    PalAuthIntegrationToJSONTyped,
} from './PalAuthIntegration';

/**
 * 
 * @export
 * @interface LeadPalInfo
 */
export interface LeadPalInfo {
    /**
     * 
     */
    execution_available: boolean;
    /**
     * 
     */
    oon_execution_available?: boolean;
    /**
     * 
     */
    oon_auto_submission_available?: boolean;
    /**
     * 
     */
    execution_available_reason: LeadPalInfoExecutionAvailableReasonEnum | null;
    /**
     * 
     */
    payor_id: string;
    /**
     * 
     */
    insurance_type: LeadPalInfoInsuranceTypeEnum | null;
    /**
     * 
     */
    latest_execution_state: LeadPalInfoLatestExecutionStateEnum | null;
    /**
     * 
     */
    auth_platform_integrations?: Array<PalAuthIntegration>;
    /**
     * 
     */
    latest_execution_created_at?: string;
    /**
     * 
     */
    latest_submission_id?: string;
    /**
     * 
     */
    latest_submission_status?: string;
    /**
     * 
     */
    latest_submission_created_at?: string;
    /**
     * The facility's active dedicated eFax inbox number, if configured. Null when eFax submissions for this facility would be sent from the shared/generic exacare fax number. Preview of the sender number resolved at actual send time — see PalAuthSubmission's sender_fax_number for what was actually used on a submission.
     */
    efax_sender_fax_number?: string;
}


/**
 * @export
 */
export const LeadPalInfoExecutionAvailableReasonEnum = {
    LeadAnalysisInProgress: 'lead_analysis_in_progress',
    NoPrimaryCommercialInsurance: 'no_primary_commercial_insurance',
    NoContractStored: 'no_contract_stored',
    PayorNotSupported: 'payor_not_supported',
    QuotaExceeded: 'quota_exceeded',
} as const;
export type LeadPalInfoExecutionAvailableReasonEnum = typeof LeadPalInfoExecutionAvailableReasonEnum[keyof typeof LeadPalInfoExecutionAvailableReasonEnum];

/**
 * @export
 */
export const LeadPalInfoInsuranceTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
} as const;
export type LeadPalInfoInsuranceTypeEnum = typeof LeadPalInfoInsuranceTypeEnum[keyof typeof LeadPalInfoInsuranceTypeEnum];

/**
 * @export
 */
export const LeadPalInfoLatestExecutionStateEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Finished: 'finished',
} as const;
export type LeadPalInfoLatestExecutionStateEnum = typeof LeadPalInfoLatestExecutionStateEnum[keyof typeof LeadPalInfoLatestExecutionStateEnum];


/**
 * Check if a given object implements the LeadPalInfo interface.
 */
export function instanceOfLeadPalInfo(value: object): value is LeadPalInfo {
    if (!('execution_available' in value) || value['execution_available'] === undefined) return false;
    if (!('execution_available_reason' in value) || value['execution_available_reason'] === undefined) return false;
    if (!('payor_id' in value) || value['payor_id'] === undefined) return false;
    if (!('insurance_type' in value) || value['insurance_type'] === undefined) return false;
    if (!('latest_execution_state' in value) || value['latest_execution_state'] === undefined) return false;
    return true;
}

export function LeadPalInfoFromJSON(json: any): LeadPalInfo {
    return LeadPalInfoFromJSONTyped(json, false);
}

export function LeadPalInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadPalInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'execution_available': json['execution_available'],
        'oon_execution_available': json['oon_execution_available'] == null ? undefined : json['oon_execution_available'],
        'oon_auto_submission_available': json['oon_auto_submission_available'] == null ? undefined : json['oon_auto_submission_available'],
        'execution_available_reason': json['execution_available_reason'],
        'payor_id': json['payor_id'],
        'insurance_type': json['insurance_type'],
        'latest_execution_state': json['latest_execution_state'],
        'auth_platform_integrations': json['auth_platform_integrations'] == null ? undefined : ((json['auth_platform_integrations'] as Array<any>).map(PalAuthIntegrationFromJSON)),
        'latest_execution_created_at': json['latest_execution_created_at'] == null ? undefined : json['latest_execution_created_at'],
        'latest_submission_id': json['latest_submission_id'] == null ? undefined : json['latest_submission_id'],
        'latest_submission_status': json['latest_submission_status'] == null ? undefined : json['latest_submission_status'],
        'latest_submission_created_at': json['latest_submission_created_at'] == null ? undefined : json['latest_submission_created_at'],
        'efax_sender_fax_number': json['efax_sender_fax_number'] == null ? undefined : json['efax_sender_fax_number'],
    };
}

export function LeadPalInfoToJSON(json: any): LeadPalInfo {
    return LeadPalInfoToJSONTyped(json, false);
}

export function LeadPalInfoToJSONTyped(value?: LeadPalInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'execution_available': value['execution_available'],
        'oon_execution_available': value['oon_execution_available'],
        'oon_auto_submission_available': value['oon_auto_submission_available'],
        'execution_available_reason': value['execution_available_reason'],
        'payor_id': value['payor_id'],
        'insurance_type': value['insurance_type'],
        'latest_execution_state': value['latest_execution_state'],
        'auth_platform_integrations': value['auth_platform_integrations'] == null ? undefined : ((value['auth_platform_integrations'] as Array<any>).map(PalAuthIntegrationToJSON)),
        'latest_execution_created_at': value['latest_execution_created_at'],
        'latest_submission_id': value['latest_submission_id'],
        'latest_submission_status': value['latest_submission_status'],
        'latest_submission_created_at': value['latest_submission_created_at'],
        'efax_sender_fax_number': value['efax_sender_fax_number'],
    };
}

